export enum ImageCategory {
  Front = 'Front',
  Rear = 'Rear',
  DriversSide = "Driver's Side",
  PassengerSide = "Passenger's Side",
  InteriorDashboard = 'Dashboard',
  InteriorSeating = 'Seating',
}

export enum UploadStatus {
  Empty,
  Success,
  Error,
  Loading,
}

export const CATEGORY_DISPLAY_ORDER = Object.values(ImageCategory);

export const getCategoryIndex = (category: string) => {
  return Object.keys(ImageCategory).indexOf(category);
};

export const getCategoryIndexFromValue = (category: ImageCategory) => {
  return Object.values(ImageCategory).indexOf(category);
};

export const getCategoryKeyFromValue = (category: ImageCategory) => {
  return Object.keys(ImageCategory)[getCategoryIndexFromValue(category)];
};

export const EMPTY_URLS = Array(6).fill('');

export const toIconName = (category: ImageCategory) => {
  return category.replace(`'s Side`, '').toLowerCase();
};

export const getLinkText = (tag: string) => {
  const index = parseInt(tag) - 1;
  return Object.values(ImageCategory)[index].toLowerCase();
};
